import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserOfferDetailsComponent } from '../../../components/user-dashboard-component/user-offer-details-component/user-offer-details-component';

@Component({
  selector: 'app-user-offer-details',
  imports: [UserOfferDetailsComponent],
  templateUrl: './user-offer-details.html',
  styleUrl: './user-offer-details.scss',
})
export class UserOfferDetails implements OnInit {
  private route = inject(ActivatedRoute);
  offerId = signal('');
  ngOnInit() {
    const offerId = this.route.snapshot.params['id'];
    this.offerId.set(offerId);
  }
}
